export default "/images/vendor/flag-icons/flags/1x1/pm.svg?b56ece89b69b4dc021b11d048e1d3367";